exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".readMore{background-color:#eaf7ff;width:100%}.readMore .rmDetails .rmTitle{font-size:34px;font-family:CeraGIRegular,sans-serif}\n", ""]);

// exports
